/**
@jsxRuntime
classic */
/** @jsx jsx */
import {jsx} from '@emotion/core'
import {CouponsConfiguration} from '../components/coupons-configurations'

function Coupons() {
  return <CouponsConfiguration />
}

export {Coupons}
